import { render, staticRenderFns } from "./FactorialMaterialList.vue?vue&type=template&id=10596b08&scoped=true&"
import script from "./FactorialMaterialList.vue?vue&type=script&lang=js&"
export * from "./FactorialMaterialList.vue?vue&type=script&lang=js&"
import style0 from "./FactorialMaterialList.vue?vue&type=style&index=0&id=10596b08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10596b08",
  null
  
)

component.options.__file = "FactorialMaterialList.vue"
export default component.exports